import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';


import { AddTransferChallanInComponent } from './addTransferChallanIn.component';

import { TransferChallanInService, SubscribeService } from '../../../services/index';

//import { AddEditSkuComponent } from './addEditSku.component';
//import { NgxPageSize } from '../../shared/index';

//import { SkuService } from '../../services/index';
import { TransferChallanInModal } from '../../../model/index';
import * as moment from 'moment';

// import * as fromSkuStore from '../../store';
// import * as skuActions from '../../store/actions/sku.actions';
// import * as fromRootStore from '../../reducers';
//import { AppMenu } from '../../../app.component.menu';
//import { AppMenuService } from '../../../app.component.service';
//import { TabsComponent} from '../../../tabs.component';

@Component({
    selector: 'tc-out-list',
    templateUrl: './transferChallanIn.component.html'
})
export class TransferChallanInComponent implements OnInit {
    @Input('tabTitle') title: string;
    // @Input() active = false;
    // @Input() isCloseable = false;
    // @Input() dataContext;
    //
    isLoadMask: Promise<any>;
    tcInListData: TransferChallanInModal[];
    //
    loadingIndicator: boolean = true;
    public mode: string;
    // reorderable: boolean = true;
    //
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        // orderBy: 'tc_in_date, tc_in_no',
        // orderDir: 'DESC'
    };
    //
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    //
    columns = [];
    toggleCol = [];
    // filterExpand = false;
    filterData = {
        "from_date": new Date(),
        "to_date": new Date(),
        "search_data": ""
    };
    printConfig: any = {
        // title: this.title,
        columns: [],
        rows: []
    };
    scrollTimeout: any;
    suppressPaging: boolean = false;
    constructor(public toasterService: ToasterService, private tcInService: TransferChallanInService, public subscribeService: SubscribeService) {
        //console.log(this.gs.rootObj);
    }

    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Tc Out Date', prop: 'tcout_date', width: 120, minWidth: 120, maxWidth: 120, toggle: true },
            { name: 'TC Out No', prop: 'tc_no', width: 100, minWidth: 100, maxWidth: 100, toggle: true },
            { name: 'From Branch', prop: 'company_name', width: 120, minWidth: 120, maxWidth: 120},
            { name: 'To Branch', prop: 'to_branch', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'HV Team', prop: 'hv_username', width: 120, minWidth: 120, maxWidth: 120},
            { name: 'Tot.Model', prop: 'tot_items', sortable: false, width: 100, minWidth: 100, maxWidth: 100, cellClass: 'cell-right' },
            { name: 'Tot.Qty', prop: 'tot_qty', sortable: false, width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-right' },
            { name: 'Tc In Date', prop: 'tcindate', width: 120, minWidth: 120, maxWidth: 120, toggle: true },
            // { name: 'Tot.Avail Qty', prop: 'tot_given_qty', sortable: false, width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-right' },
            { name: 'TC In No', prop: 'tc_in_no', width: 100, minWidth: 100, maxWidth: 100, toggle: true },
            { name: 'Rec.Model', prop: 'tot_recieved_items', sortable: false, width: 100, minWidth: 100, maxWidth: 100, cellClass: 'cell-right' },
            { name: 'Rec.Qty', prop: 'tot_recieved_qty', sortable: false, width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-right' },
            { name: 'Action', prop: 'action', width: 280, minWidth: 280, maxWidth: 280, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.toggleCol = Object.assign({}, this.columns);
        this.pageCallback({ offset: 0 });

        // this.subscribeService.subscribe(($e) => {
        //     this.pageCallback({ offset: 0 });
        // });
        this.subscribeService.publishReloadTransferInListGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterTextBox').focus();
        }, 100);

    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getTcInDateList();
    }

    onColumnToggle(colToShow) {
        console.log(colToShow);
        this.columns = colToShow;
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getTcInDateList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    clearFilter(): void {
        this.filterData = {
            "from_date": new Date(),
            "to_date": new Date(),
            "search_data": ""
        };
        this.applyFilter();
    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getTcInDateList();
    }
    getTcInDateList(): void {
        let filterData = {
            ...this.filterData,
            from_date:moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date:moment(this.filterData['to_date']).format('YYYY-MM-DD')
        };
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            // orderColumn: `${this.page.orderBy}`,
            // orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(filterData)
        };
        let that = this;
        //this.store.dispatch(new commonActions.LoadAllSku(params));
        this.isLoadMask = this.tcInService
            .getTcInList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.tcInListData = res.data;
            });
    }
    addEditTcIn(mode: string, row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);

        if (mode == 'Add' || (row && !row.tc_in_no)) {
            if (!row) {
                row = {
                    'tc_in_id': ''
                };
            }
            row['mode'] = 'Add';
            row['btnTxt'] = 'Save';
        } else if (mode == "Edit") {
            row['mode'] = mode;
            row['btnTxt'] = 'Update';
        } else if (mode == "View") {
            row['mode'] = mode;
            //row['btnTxt'] = 'Update';
        }
        that.subscribeService.subScribeTabID('Transaction', 'AddTransferChallanInComponent', Object.assign({}, row), this['params']['tabParams']);

    }
    deleteTcIn(row: any): void {
        let that = this,
            data = {
                tcinid: row.tc_in_id,
                frombranchid: row.from_branch_id,
                branchid: row.branch_id,
                tcno: row.tc_no,
                tc_out_id: row.tc_out_id
            };
        that.tcInService
            .deleteTcIn(data)
            .then(function(res: any) {
                that.loadingIndicator = false;
                if (res.success) {
                    that.getTcInDateList();
                    swal(
                        'Deleted',
                        res.message,
                        'success'
                    );
                } else {
                    swal(
                        'ERROR',
                        res.message,
                        'error'
                    );
                }
            });


    }

    acceptTCIn(row: any): void {
        let that = this,
            params: any = {
                tc_out_id: row.tc_out_id,
                companyid: row.from_comp_id,
                out_type: row.out_type,
                requested_by: row.requested_by,
                tc_indate: moment(new Date()).format('YYYY-MM-DD'),
                mode: 'Accept'
            };
        this.isLoadMask = this.tcInService.getTcNoData(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                if (res && res.data) {
                    params.particulars = JSON.stringify(res.data);
                    that.isLoadMask = that.tcInService.addTransferChellanIn(params).then(function(res: any) {
                        if (res.success) {
                            swal(
                                'SUCCESS',
                                res.message,
                                'success'
                            );
                            that.subscribeService.subReloadTransferInListGrid();
                        } else {
                            swal(
                                'ERROR',
                                res.message,
                                'error'
                            );
                        }
                    });
                }
            });
    }

    
    @ViewChild('printPage') printPage;
    onPrintReport(row: any) {
        let params={
            start: 0,
            limit: 20,
            orderColumn:"cci.tc_in_id",
            orderBy:"cci.tc_in_id",
            orderDir:"asc",
            tc_in_id: row.tc_in_id
        }
        let that = this;
        that.isLoadMask = this.tcInService
            .getTransferChallanInModelDetails(params)
            .then(function(res:any){
                row['list']=res.data;
                that.printConfig = {
                    type: that.title,
                    title: 'SOUNDS GOOD HEARING CARE',
                    subTitle: that.title,
                    rows: row,
                    columns: that.columns

                    /*  fromdate: that.datePipe.transform(that.filterData['from_date'], 'dd-MM-yyyy'),
                     todate: that.datePipe.transform(that.filterData['date'], 'dd-MM-yyyy') */
                }

                setTimeout(() => {
                    that.printPage.printPreview();
                }, 100);
            })
      
        /*setTimeout(() => {
            that.filterPanel.close();
        }, 100);*/
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/transferChallanIn/transferChallanIn.component.ts